import Page from 'views/Pages'

export default Page